
import api from "core/api/api";
import metaObjectConverter from "core/services/metaStoreService/metaobject-converter";

export class TransformationUtils {
    static getInputStreamName(streamID: string): string {
        return api.getCurrentNamespace() === metaObjectConverter.getNamespace(streamID)
            ? metaObjectConverter.getName(streamID)
            : metaObjectConverter.convertFullNameToShortName(streamID);
    }
}
